export default __webpack_public_path__ + "assets/NexwayLogo425x120.3866b77ea009794844d8490b36a778cd.png";